module.exports = __webpack_public_path__ + "static/beermap-faaa3a26837867660baef0d4c469e5a6.png";